import { tracked } from '@glimmer/tracking';

import type { GeneralComponentClass } from 'webapp-types';

import InfolayerTypeReportPdfComponent from 'webapp/components/infolayer/type-report-pdf';

import type {
	ConstructorData as BaseConstructorData,
	onCloseFn,
} from 'webapp/models-custom/infolayer-item/base';
import InfolayerItemBase from 'webapp/models-custom/infolayer-item/base';
import InfolayerSnapshotBase from 'webapp/models-custom/infolayer-item/snapshot-base';
import type ReportDelivery from 'webapp/models-custom/report-delivery';

export interface ReportDeliveryLikeType {
	reportId: number | null;
	title: string;
	sizeFormatted?: string;
	reportUrl?: string;
}

export interface ConstructorData extends BaseConstructorData {
	reportDelivery: ReportDeliveryLikeType;
}

export default class InfolayerItemReportPdf extends InfolayerSnapshotBase {
	componentClass: GeneralComponentClass = InfolayerTypeReportPdfComponent;

	@tracked reportDelivery: ReportDeliveryLikeType;

	constructor(data: ConstructorData, onClose: onCloseFn) {
		super(data, onClose);

		this.reportDelivery = data.reportDelivery;
	}

	override setDone(sentReportDelivery: ReportDelivery) {
		this.reportDelivery = sentReportDelivery;
		super.setDone(sentReportDelivery);
	}

	protected override isSameType(item: InfolayerItemBase) {
		return super.isSameType(item) && item instanceof InfolayerItemReportPdf;
	}
}
